module.exports = __webpack_public_path__ + "static/media/default-profile.5f9af5e1.jpg";